export const getRefreshDataHeader = (refreshData: boolean) => {
  if (!refreshData) {
    return {};
  }

  return {
    headers: {
      RefreshData: 'true',
      'Cache-Control': 'no-store',
      Pragma: 'no-cache',
    },
  };
};
